var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner'),(_vm.getConfigValue('isOrderCreatingDisabled'))?_c('info'):_vm._e(),_c('popular-products'),_c('catalog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }